// extracted by mini-css-extract-plugin
export default {"hd1":"OtherWaystoLearn_hd1__GVLAT","hd2":"OtherWaystoLearn_hd2__AfDo+","tx1":"OtherWaystoLearn_tx1__PI+zm","tx2":"OtherWaystoLearn_tx2__IuhaJ","bxfx":"OtherWaystoLearn_bxfx__izNRr"};